import { render, staticRenderFns } from "./CustomTimer.vue?vue&type=template&id=1f96a4ae&scoped=true"
import script from "./CustomTimer.vue?vue&type=script&lang=js"
export * from "./CustomTimer.vue?vue&type=script&lang=js"
import style0 from "./CustomTimer.vue?vue&type=style&index=0&id=1f96a4ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f96a4ae",
  null
  
)

export default component.exports